var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.99973 14.6669C11.1919 14.6669 13.7797 12.0791 13.7797 8.88693C13.7797 5.69473 11.1919 3.10693 7.99973 3.10693C4.80752 3.10693 2.21973 5.69473 2.21973 8.88693C2.21973 12.0791 4.80752 14.6669 7.99973 14.6669Z",
    fill: "#282829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16683C7.72667 9.16683 7.5 8.94016 7.5 8.66683V5.3335C7.5 5.06016 7.72667 4.8335 8 4.8335C8.27333 4.8335 8.5 5.06016 8.5 5.3335V8.66683C8.5 8.94016 8.27333 9.16683 8 9.16683Z",
    fill: "#282829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92611 2.30016H6.07277C5.80611 2.30016 5.59277 2.08683 5.59277 1.82016C5.59277 1.5535 5.80611 1.3335 6.07277 1.3335H9.92611C10.1928 1.3335 10.4061 1.54683 10.4061 1.8135C10.4061 2.08016 10.1928 2.30016 9.92611 2.30016Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.96160cd2adf7e517bcf0ad4a0f857438.svg";
export { ForwardRef as ReactComponent };